import React from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const OperatorsDetails = ({ operator }) => {
    const [modalShow, setModalShow] = React.useState(false);


    console.log(operator, "operatormodal")

    return (
        <>
            <div className='opertoDetailSectionMOda' variant="primary" onClick={() => setModalShow(true)}>
                Click Here to read about {operator?.companyname} Luggage allowance, Cancellation policy and Terms & Conditions.
            </div>

            <Modal
                show={modalShow} // Pass the state to control visibility
                onHide={() => setModalShow(false)}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {operator?.companyname}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='descripInnerModal'>
                        <div className="operateDetailSection">
                            <div className="launageText">Luggage allowance:</div>
                            <div className="launageTextDetail">{operator?.luggageAllowance} Piece</div>
                        </div>
                        <div className="" style={{ marginTop: "20px" }}>
                            <div className="launageText" style={{ textAlign: "center" }}>Cancellation policy</div>
                            <div className="launageTextDetail" style={{ textAlign: "justify" }}>{operator?.cancellation_Policy}</div>
                        </div>
                        <div className="" style={{ marginTop: "20px" }}>
                            <div className="launageText" style={{ textAlign: "center" }}>Terms & Conditions</div>
                            <div className="launageTextDetail" style={{ textAlign: "justify" }}>{operator?.Terms_Conditions}</div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button className='descrip-closeBtn' onClick={() => setModalShow(false)}>Close</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default OperatorsDetails
